import React, { useState } from 'react';
import HeroSection from '../components/HeroSection';
import ServicesSection from '../components/ServicesSection';
import PhilosophySection from '../components/PhilosophySection';
import TeamSection from '../components/TeamSection';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';
import Header from '../components/Header';
import WhatsAppButton from '../components/WhatsAppButton';
import { Toaster } from '../components/ui/sonner';

const Home = () => {
  const [activeSection, setActiveSection] = useState('inicio');

  return (
    <div className="min-h-screen bg-cream-50">
      <Header activeSection={activeSection} setActiveSection={setActiveSection} />
      <main>
        <HeroSection />
        <ServicesSection />
        <PhilosophySection />
        <TeamSection />
        <ContactSection />
      </main>
      <Footer />
      <WhatsAppButton />
      <Toaster position="top-center" richColors />
    </div>
  );
};

export default Home;